import React from "react";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ApiIcon from "@mui/icons-material/Api";
import GroupsIcon from "@mui/icons-material/Groups";

export const homeDigitalMarketingServices = [
  {
    title: "Email campaigns",
    text: "25-40% higher open rates, 3-5x more sales from automated sequences, proven ROI tracking.",
    icon: <MailOutlineIcon sx={{ fontSize: 28 }} />,
  },
  {
    title: "SMS Campaigns",
    text: "Reach and engage customers through text messages.",
    icon: <ApiIcon sx={{ fontSize: 28 }} />,
  },
  {
    title: "Audience Management",
    text: "Organize contacts into smart groups, filter by engagement, and deploy embeddable website forms to build your list on autopilot.",
    icon: <GroupsIcon sx={{ fontSize: 28 }} />,
  },
];
